import {FolderDTO} from '../../api/data-contracts'

function FolderBadges(props: {folder: FolderDTO}) {
  return (
    <div className='d-flex'>
      {(props.folder.notDownloadedDocumentCount ?? 0) > 0 && (
        <div className='w-35px d-flex justify-content-end'>
          <span className='badge badge-info' title='Yeni Dosya'>
            {props.folder.notDownloadedDocumentCount}
          </span>
        </div>
      )}
      {(props.folder.missingDocumentCount ?? 0) > 0 && (
        <div className='w-30px d-flex justify-content-end'>
          <span className='badge badge-danger' title='Yüklenmesi Gereken Eksik Döküman Sayısı'>
            {props.folder.missingDocumentCount}
          </span>
        </div>
      )}
    </div>
  )
}

export default FolderBadges
